import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";

import AdminRoutes from "./routes/AdminRoutes";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Navigate to="/admin" replace />} />

          <Route path="/login" element={<Navigate to="/admin" replace />} />

          {/* ADMIN */}
          <Route path="/admin/*" element={<AdminRoutes />} />

          <Route path="*" element={<Navigate to="/admin" replace />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
